export const STEP_FLIGHT_PACKAGE_RESULTS = 10;
export const DEFAULT_PACKAGE_AIR_FILTERS = {
  OrderDesc: false,
  Airlines: [],
  Alliances: [],
  BusClass: [],
  Stops: [],
  SectorDurations: [],
  DepartureTimes: [],
  PriceFrom: undefined,
  PriceTo: undefined,
  DepartureAirports: [],
  ArrivalAirports: [],
  BaggagesQuantity: [],
  Tags: []
};
